import axios from 'axios';
import config from '../../../config';

const baseUrl = config.baseUrl;
const productosEndpoint = '/api/financiero/productos';
const asignacionesEndpoint = '/api/financiero/productos/asignaciones';


//Sostenibilidad
export const getProductos = async () => {
    const response = await axios.get(`${baseUrl}${productosEndpoint}`);
    return response.data;
};

export const createProducto = async (productoData) => {
    const response = await axios.post(`${baseUrl}${productosEndpoint}`, productoData);
    return response.data;
};

export const updateProducto = async (id, productoData) => {
    const response = await axios.put(`${baseUrl}${productosEndpoint}/${id}`, productoData);
    return response.data;
};

export const deleteProducto = async (id) => {
    const response = await axios.delete(`${baseUrl}${productosEndpoint}/${id}`);
    return response.data;
};


export const postAsignaciones = async (payload) => {
    try {
        const res = await axios.post(`${baseUrl}${asignacionesEndpoint}`, payload);
        // res.status será 201 o 200 en éxito
        return { statusCode: res.status, ...res.data }; // {statusCode, status, message, data}
    } catch (err) {
        // Si el backend respondió con 4xx/5xx
        if (err?.response) {
            const { status, data } = err.response;
            // Propaga un objeto consistente
            throw {
                statusCode: status,
                status: data?.status ?? status,
                message: data?.message || 'Error en la solicitud',
                data: data?.data,
            };
        }
        // Si es un error de red u otro
        throw {
            statusCode: 0,
            status: 0,
            message: err?.message || 'Error de red',
        };
    }
};